<template>
    <!-- 会员管理－补预约 -->
    <div class="repair">
        <content-view v-show="$utils.renderWhen(this,'repairOrder')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="vip-form">
                    <a-form-item label="会员手机号">
                        <a-input placeholder="请输入" v-decorator="['phone', {rules: [{required: true, message: '请输入手机号'}]}]" @pressEnter="search(ableReserve)"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="search(ableReserve)" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card :bordered="false">
                <template slot="extra" v-if="getBtnByAuth('exportUse')">
                    <a-button v-if="ableReserve" type="primary" @click="search(false)" :loading="loading">展示全部票券</a-button>
                    <a-button v-else type="primary" @click="search(true)" :loading="loading">仅展示可补预约票券</a-button>
                </template>
                <a-table :loading="loading" bordered :dataSource="dataSource" :columns="columns" @change="changePage" :pagination="pagination" :rowKey="record => record.userTicketNo">
                    <span slot="type" slot-scope="text">{{['', '期限卡', '次卡', '套餐票'][text]}}</span>
                    <span slot="validTime" slot-scope="a,row">{{row.validStartTime | dateSplit}}~{{row.validEndTime | dateSplit}}</span>
                    <span slot="showState" slot-scope="showState">{{$utils.ticketState[showState]}}</span>
                    <span slot="phone">{{account || "-"}}</span>
                    <span slot="action" slot-scope="a, row">
                        <template>
                            <a v-if="getBtnByAuth('requiredSave') && row.isNeedReserve && !row.isCannotOrder" class="text-primary" @click="orderInventory(row.userTicketNo, row.ticketTemplateId, row.phone, row.userId, false)">补预约</a>
                            <a v-else class="text-disabled">补预约</a>
                        </template>
                        <a-divider></a-divider>
                        <template>
                            <a v-if="getBtnByAuth('forcereservation') && row.isNeedReserve && !row.isCannotOrder" class="text-primary" @click="orderInventory(row.userTicketNo, row.ticketTemplateId, row.phone, row.userId, true)">强制预约</a>
                            <a v-else class="text-disabled">强制预约</a>
                        </template>
                    </span>
                </a-table>
            </a-card>
            <a-modal
                v-if="visible"
                :visible="true"
                :title="reserveData.isForce?'强制预约':'补预约'"
                okText="确认预约"
                @ok="handleOk"
                @cancel="closeModal"
                :confirmLoading="confirmLoading"
                >
                <a-form :form="formOrder">
                    <a-form-item label="预约门店：" :labelCol="{span: 4}" :wrapperCol="{span: 10}">
                        <a-select placeholder="请选择" :labelInValue="true" style="width:360px" @change="changeShop" v-decorator="['shopId', {rules: [{required: true, message: '请选择'}]}]">
                            <a-select-option :value="item.shopId" v-for="item in selectList" :key="item.shopId" >{{item.shopName}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="预约日期：" :labelCol="{span: 4}" :wrapperCol="{span: 10}">
                        <a-date-picker :disabledDate="disabledDate" @change="onChange" style="width:360px" v-decorator="['reserveDate', {rules: [{required: true, message: '请选择'}]}]"/>
                    </a-form-item>
                    <a-form-item label="预约场次：" :labelCol="{span: 4}" :wrapperCol="{span: 16}" :required="true">
                        <span v-if="reservePeriod.length === 0">暂无场次</span>
                        <div v-else class="repair-order">
                            <div class="repair-order-reserve" @click="checkRadio(item)" v-for="item in reservePeriod" :key="item.id">
                                <div>
                                    <span>{{item.name}}</span> 
                                    <a-radio class="float-right" :checked="item.isChecked"></a-radio>
                                </div>
                                <div>{{item.startTime && item.startTime.substr(0,5)}}-{{item.endTime && item.endTime.substr(0,5)}}</div>
                                <div class="text-primary">名额：剩余{{item.capacity - item.reserveNum}}个</div>
                            </div>
                        </div>
                    </a-form-item>
                    <a-form-item label="预约次数：" :labelCol="{span: 4}" :wrapperCol="{span: 16}">
                        <a-input-number style="width:100px" v-model="reserveData.num" :min="1" :max="num" v-decorator="['reserveNum', {rules: [{required: true, message: '请输入'}]}]"/> <span v-if="reserveData.periodId">最多可预约{{num == Infinity ? '无限' : num}}次</span>
                    </a-form-item>
                    <a-row class="mb16" v-if="reserveData.periodId">
                        <a-col>该票券在预约日期内已预约次数: {{orderLimitDetail.reserveNum || 0}}</a-col>
                        <a-col>票券剩余次数: {{orderLimitDetail.remainNum == -1 ? '不限次' : orderLimitDetail.remainNum}}</a-col>
                        <a-col>单日限制预约次数: {{orderLimitDetail.dayReserveLimit == -1 ? '不限次' :orderLimitDetail.dayReserveLimit}}</a-col>
                    </a-row>
                    <remark :labelSpan="4" :wrapperSpan="16" :operateCode="reserveData.isForce ? 'ForceReserve':'RepairReserve'" />
                </a-form>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import remark from '@/components/modules/platform/remark.component';
    export default {
    name: "repairOrder",
        components: {remark},
        props: {},
        data() {
            const tabListNoTitle = [
                {
                    key: '3',
                    tab: '已支付',
                    columnLine: columns
                },
                {
                    key: '2',
                    tab: '支付失败',
                    columnLine: columns
                },
                {
                    key: '4',
                    tab: '已过期',
                    columnLine: columns
                },
                {
                    key: '5',
                    tab: '已失效',
                    columnLine: columns
                },
                {
                    key: '6',
                    tab: '退款中',
                    columnLine: columns
                },
                {
                    key: '7',
                    tab: '已退款',
                    columnLine: columns
                },
                {
                    key: '8',
                    tab: '退款失败',
                    columnLine: columns
                },
                {
                    key: '9',
                    tab: '已禁用',
                    columnLine: columns
                },
            ]
            const columns = [
            {
                title: "用户票券号/卡号",
                dataIndex: "userTicketNo"
            },
            {
                title: "会员手机号",
                dataIndex: "phone",
                scopedSlots: { customRender: "account" }
            },
            {
                title: "票券内部标识",
                dataIndex: "name"
            },
            {
                title: "票券展示名称",
                dataIndex: "showName"
            },
            {
                title: "票券类型",
                dataIndex: "type",
                scopedSlots: { customRender: "type" }
            },
            {
                title: "票券有效期",
                dataIndex: "validTime",
                scopedSlots: { customRender: "validTime" }
            },
            {
                title: "状态",
                dataIndex: "showState",
                scopedSlots: { customRender: "showState" }
            },
            {
                title: "操作",
                key: "action",
                scopedSlots: { customRender: "action" }
            }];
            return {
                columns,
                dataSource: [],
                selectList: [],
                visible: false,
                isChecked: false,
                reserveData: {},
                num: undefined,
                reservePeriod: [],
                userTicketPrivilegeList: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                confirmLoading: false,
                tabListNoTitle,
                noTitleKey: '3',
                remarkList: [],
                orderLimitDetail: {},
                ableReserve: false,
            };
        },
    computed: {},
    filters: {
        dateSplit(val) {
            if (!val) return;
            return val.substring(0, 10);
        }
    },
    methods: {
        // 分页change
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getList()
        },

        onTabChange(noTitleKey) {
            this.noTitleKey = noTitleKey
            this.pagination.current = 1;
            this.getList()
        },
        // 搜索条件重置
        handleReset () {
            this.pagination.pageSize = 20
            this.pagination.current = 1
            this.pagination.total = 0;
            this.dataSource = [];
            this.form.resetFields();
            this.getList()
        },
        search(ableReserve) {
            if (!this.form.getFieldValue("phone")) return;
            this.ableReserve = ableReserve;
            this.pagination.current = 1;
            this.getList();
        },
        // 获取列表
        getList() {
            this.form.validateFields((err, values) => {
                if (err) return;
                if (!values.phone) return;
                this.loading = true;
                this.$api.member.queryUserTicketSuppleReservePage({
                    body: Object.assign(values, {
                        ableReserve: this.ableReserve || undefined,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                    })
                }).then(res => {
                    this.loading = false
                    res.list.forEach(el => {
                        el.isCannotOrder = (el.totalNum - el.usedNum == 0 && el.totalNum != -1) || ["isForbidden", "isFrozen", "isInvalid", "isLocked"].find(item => item[el]);
                    })
                    this.pagination.total = res.total;
                    this.dataSource = res.list;
                }).catch( err => {
                    this.loading = false
                })
            });
        },
        // 打开补预约弹框
        orderInventory(userTicketNo, ticketId, account, userId, isForce) {
            this.visible = true
            this.reserveData.userTicketNo = userTicketNo;
            this.reserveData.ticketId = ticketId;
            this.reserveData.account = account;
            this.reserveData.userId = userId;
            this.reserveData.isForce = isForce;
            this.reservePeriod = []
            this.reserveData.reserveStockId = ''
            this.num = undefined;
            this.getOrderDate();
            this.getReserveTime();
        },
        getOrderDate() {
            this.$api.member.getOrderDate({
                params: {ticketId: this.reserveData.ticketId}
            }).then(res => {
                this.selectList = res.filter(el => {
                    el.label = el.shopName;
                    el.value = el.shopId;
                    return el.reserveStockId
                });
            });
        },

        // 选中该门店 切换票券权限
        changeTicket(value) {
            this.reserveData.userTicketPrivilegeId = value
            this.reserveData.reserveStockId = ''
            this.reservePeriod.forEach(ele => {
                this.$set(ele, 'isChecked', false)
            })
            this.num = undefined
        },

        // 选中该门店 切换场次
        changeShop(value) {
            const selectList = this.selectList.find(el => value.key == el.shopId) || {}
            Object.assign(this.reserveData, selectList);
            if(!this.reserveData.reserveDate) {
                this.$message.warning('请选择预约日期')
                return
            }
            this.getReservePeriod();
            this.getReserveTime();
        },

        // 日期切换时 切换场次
        onChange(date, dateString) {
            this.reserveData.reserveDate = dateString
            if(!this.reserveData.shopId) {
                this.$message.warning('请选择门店')
                return
            }
            this.getReservePeriod();
            this.getReserveTime();
        },
        disabledDate(current) {
            // Can not select days before today and today
            return current && current < this.$moment().subtract(1,'days');
        },

        // 根据门店ID和日期获取 场次
        getReservePeriod() {
            this.$api.member.getPeriodByDate({
                body: {
                    startDate: this.reserveData.reserveDate,
                    endDate: this.reserveData.reserveDate,
                    reserveStockId: this.reserveData.reserveStockId,
                }
            }).then(res => {
                this.reservePeriod = res[0].periodVos || [];
                this.reservePeriod.forEach(item => {
                    this.$set(item, 'isChecked', false)
                });
            });
        },

        // 选中该场次
        checkRadio(item) {
            this.reservePeriod.forEach(ele => {
                this.$set(ele, 'isChecked', false)
            })
            this.$set(item, 'isChecked', true)
            this.reserveData.periodId = item.id
            this.reserveData.reservePeriod = item.name
        },
        getReserveTime() {
            if(!this.reserveData.userTicketNo || !this.reserveData.reserveDate) return 
            this.$api.member.getUserTicketDetails({
                params: {
                    userTicketNo: this.reserveData.userTicketNo,
                },
                query: {
                    date: this.reserveData.reserveDate,
                }
            }).then(res => {
                /**
                 * 
                    totalSurplus：总剩余可预约次数 -1表示不限次
                    daySurplus：单日剩余预约次数
                    remindNum：剩余可预约次数
                    dayLimit：单日限制预约次数 -1表示不限次
                    num：可预约次数 三者取最小
                 */
                this.orderLimitDetail = res;
                let dayReserveLimit = res.dayReserveLimit === -1 ? Infinity : res.dayReserveLimit;
                let remainNum = res.remainNum === -1 ? Infinity : res.remainNum;
                let reserveNum = res.reserveNum === -1 ? Infinity : res.reserveNum;
                this.num = Math.min(dayReserveLimit, remainNum);
                this.num = this.num === -1 ? Infinity : this.num;
            })
        },
        // 保存补预约
        handleOk() {
            if(!this.reserveData.periodId) {
                this.$message.error('请选择预约场次')
                return
            }
            this.formOrder.validateFields((err, values) => {
                if (err) return;
                this.confirmLoading = true
                this.$api.member.reserve({
                    body: {
                        isForce: this.reserveData.isForce,
                        isSupple: this.reserveData.isForce ? false : true,
                        phone: this.reserveData.account,
                        reserveNum: values.reserveNum,
                        userTicketNo: this.reserveData.userTicketNo,
                        reserveStockPeriodId: this.reserveData.periodId,
                        remark: values.remark,
                        remarkCategoryCode: values.remarkCategoryCode,
                        remarkCategoryName: values.remarkCategoryName,
                        userId: this.reserveData.userId,
                    }
                }).then(res => {
                    this.confirmLoading = false
                    this.getList()
                    this.visible = false
                    this.$message.success('操作成功')
                })
                .catch(err => {
                    this.confirmLoading = false
                })
            });
        },

        // 关闭补预约弹框
        closeModal() {
            this.reserveData = {}
            this.visible = false
        },
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
        this.formOrder = this.$form.createForm(this)
    },
    created() {},
    mounted() {
        this.getList()
    }
};
</script>
<style lang="scss"> 
    .repair {
        &-box {
            display: flex;
        }
        &-order {
            width: 320px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            &-reserve {
                width: 150px;
                height: 86px;
                line-height: 24px;
                margin-bottom: 16px;
                padding: 8px 10px;
                border-radius: 4px;
                border: 1px solid rgba(217,217,217,1);
                cursor: pointer;
            }
        }
    }
</style>